import { Component, Input, ViewChild } from '@angular/core';
import { MatExpansionPanel, MatAccordion, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { SharedService } from '../../../../shared/services/shared.service';
import { MatIcon } from '@angular/material/icon';
import { SafeHtmlPipe } from '../../../pipe/safe-html.pipe';

@Component({
    selector: 'app-notification-popup',
    templateUrl: './notification-popup.component.html',
    styleUrl: './notification-popup.component.css',
    imports: [MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatIcon, SafeHtmlPipe]
})
export class NotificationPopupComponent {
  @Input() notificationList: any = [];
  openedPanelNumber: any = -1;
  closedPanelNumber: any = -1;
  @ViewChild('panel') panel: MatExpansionPanel;

  constructor(private sharedService: SharedService) { }
}
